import { useEffect, useState } from "react";

function DMCABadge() {
  
 const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true); 
  }, []);
  useEffect(() => {
    if(!mounted) return;
    const badgeClass = "dmca-badge";
    const paramName = "refurl";
    const links = document.querySelectorAll(`a.${badgeClass}`);

    if (links.length > 0 && !links[0].href.includes(paramName)) {
      links.forEach(link => {
        link.href += (link.href.includes("?") ? "&" : "?") + `${paramName}=${encodeURIComponent(window.location.href)}`;
      });
    }
  }, [mounted]); 

  if (!mounted) return null; 

  return (
   <a
      href="//www.dmca.com/Protection/Status.aspx?ID=f4bb5935-60ba-4a88-a17d-43b473a5363b"
      title="DMCA.com Protection Status"
      target="_blank"
      className="dmca-badge"
    >
      <img 
      width={256}
  height={450}
        src="https://images.dmca.com/Badges/dmca_protected_sml_120n.png?ID=f4bb5935-60ba-4a88-a17d-43b473a5363b"
        alt="DMCA.com Protection Status"
      />
    </a>
  );
}

export default DMCABadge;
